module.exports = {
  homeArtistData: "/api.php?act=home", //艺人主页&东娱主页
  listData: "/api.php?act=list", //列表页
  businessContactData: "/api.php?act=getBusiness",//商务人员资料数据
  artistListData: "/api.php?act=artist", //艺人列表数据
  getUserUid: "/api.php?act=getUid",//获取用户UID
  getJssdk: "/jssdk.php" //微信JSSDK参数
}

